import { TogglesState, isfeatureToggleAction } from 'common/feature-togglings/reducer'
import { Middleware } from 'common/store'
import { Features } from 'common/features'

export function configureTrackJs(version: string) {
    if (typeof window === 'object' && (window as any).trackJs) {
        trackJs.configure({ version })
    }
}

export function updateTrackJsSectionMetadata(section: string) {
    if (typeof window === 'object' && (window as any).trackJs) {
        trackJs.addMetadata(`section`, section)
    }
}

export function updateTrackJsFeatureMetadata(toggleState: TogglesState) {
    if (typeof window === 'object' && (window as any).trackJs) {
        const { featureState } = toggleState
        for (const featureName in featureState) {
            if (featureState.hasOwnProperty(featureName)) {
                const feature = featureState[featureName as Features]
                if (typeof feature === 'object') {
                    trackJs.addMetadata(`feature_${featureName}`, feature.enabled)
                }
            }
        }
    }
}

export function logInTrackJS(error: string | Error) {
    if (typeof window === 'object' && (window as any).trackJs) {
        trackJs.track(error)
    }
}

export function getTrackJSMiddleware() {
    const trackJSMiddleware: Middleware = api => next => action => {
        const dispatch = next(action)
        if (isfeatureToggleAction(action)) {
            updateTrackJsFeatureMetadata(api.getState().toggles)
        }
        return dispatch
    }
    return trackJSMiddleware
}
